module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "new"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Actuellement")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.new), function(newPlate, index) {
    return (index < Math.ceil(_vm.menuData.new.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(newPlate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(newPlate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(newPlate.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.new), function(newPlate, index) {
    return (index >= _vm.menuData.new.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(newPlate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(newPlate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(newPlate.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "pizza"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Pizzas")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pizzas), function(pizza, index) {
    return (index < Math.ceil(_vm.menuData.pizzas.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pizza.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pizza.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pizza.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pizzas), function(pizza, index) {
    return (index >= _vm.menuData.pizzas.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pizza.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pizza.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pizza.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "bruschette"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Bruschette")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.bruschette), function(bruschetta, index) {
    return (index < Math.ceil(_vm.menuData.bruschette.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(bruschetta.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(bruschetta.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(bruschetta.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.bruschette), function(bruschetta, index) {
    return (index >= _vm.menuData.bruschette.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(bruschetta.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(bruschetta.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(bruschetta.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "pasta"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Pâtes")]), _vm._v(" "), _c('span', {
    staticClass: "section-suptitle text-center"
  }, [_vm._v("Spaghetti • Penne • Rigatoni • Orecchiette • Tagliatelle")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pates), function(pate, index) {
    return (index < Math.ceil(_vm.menuData.pates.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pates), function(pate, index) {
    return (index >= _vm.menuData.pates.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "home-pasta"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Pâtes maison")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.patesmaison), function(pate, index) {
    return (index < Math.ceil(_vm.menuData.patesmaison.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.patesmaison), function(pate, index) {
    return (index >= _vm.menuData.patesmaison.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "risotto"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Risottos")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.risottos), function(risotto, index) {
    return (index < Math.ceil(_vm.menuData.risottos.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(risotto.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(risotto.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(risotto.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.risottos), function(risotto, index) {
    return (index >= _vm.menuData.risottos.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(risotto.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(risotto.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(risotto.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "salad"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Salades")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.menuData.salades), function(salade, index) {
    return (index < Math.ceil(_vm.menuData.salades.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(salade.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(salade.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(salade.price))]), _vm._v(" "), _c('span', {
      staticClass: "offer-hprice"
    }, [_vm._v(_vm._s(salade.hprice))])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.menuData.salades), function(salade, index) {
    return (index >= _vm.menuData.salades.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(salade.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(salade.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(salade.price))]), _vm._v(" "), _c('span', {
      staticClass: "offer-hprice"
    }, [_vm._v(_vm._s(salade.hprice))])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "desserts"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Desserts")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.desserts), function(dessert, index) {
    return (index < Math.ceil(_vm.menuData.desserts.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(dessert.name))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(dessert.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.desserts), function(dessert, index) {
    return (index >= _vm.menuData.desserts.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(dessert.name))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(dessert.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), (!_vm.isMobile()) ? _c('section', {
    staticClass: "parallax-window",
    attrs: {
      "id": "deco",
      "data-background": "static/img/bg/dessert.jpg"
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "drink"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v("Boissons")]), _vm._v(" "), _c('h4', {
    staticClass: "section-title"
  }, [_vm._v("\n            Bouteilles 5dl\n          ")]), _vm._v(" "), _vm._l((_vm.menuData.boissons.dl), function(boisson, index) {
    return _c('div', {
      staticClass: "drink-item"
    }, [_c('span', [_vm._v(_vm._s(boisson.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(boisson.price))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v("Boissons")]), _vm._v(" "), _c('h4', {
    staticClass: "section-title"
  }, [_vm._v("\n            Canettes 33cl\n          ")]), _vm._v(" "), _vm._l((_vm.menuData.boissons.cl), function(boisson, index) {
    return _c('div', {
      staticClass: "drink-item"
    }, [_c('span', [_vm._v(_vm._s(boisson.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(boisson.price))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v("Boissons")]), _vm._v(" "), _c('h4', {
    staticClass: "section-title"
  }, [_vm._v("\n            Bouteilles 1l\n          ")]), _vm._v(" "), _vm._l((_vm.menuData.boissons.l), function(boisson, index) {
    return _c('div', {
      staticClass: "drink-item"
    }, [_c('span', [_vm._v(_vm._s(boisson.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(boisson.price))])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer-item"
  }, [_c('div', [_c('h3', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")])]), _vm._v(" "), _c('span', {
    staticClass: "offer-price"
  }, [_c('i', {
    staticClass: "fa fa-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "offer-hprice"
  }, [_c('i', {
    staticClass: "fa fa-adjust",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer-item second"
  }, [_c('div', [_c('h3', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")])]), _vm._v(" "), _c('span', {
    staticClass: "offer-price"
  }, [_c('i', {
    staticClass: "fa fa-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "offer-hprice"
  }, [_c('i', {
    staticClass: "fa fa-adjust",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67560f14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 15
// module chunks = 0